import { render, staticRenderFns } from "./ReaderCard.vue?vue&type=template&id=ff69f312&scoped=true&"
import script from "./ReaderCard.vue?vue&type=script&lang=js&"
export * from "./ReaderCard.vue?vue&type=script&lang=js&"
import style0 from "./ReaderCard.vue?vue&type=style&index=0&id=ff69f312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff69f312",
  null
  
)

export default component.exports